/**
 * Collection of urls to different url configurations.
 */
let urls: {
  /**
   * Specifies the base path of the application, so that all internal routing
   * will be properly resolved.
   */
  basePath: string;

  /**
   * Contains an absolute url to the overview application, which is used to
   * redirect users back there after signout.
   */
  mfOverview: string;

  /**
   * Contains an absolute url to the external gPanels script, which is used to
   * inject the status plugin.
   */
  gPanels: string;

  /**
   * Contains an absolute url to the gExport script, which is used to
   * generate screenshots of some pages.
   */
  gExport: string;

  /**
   * Contains the absolute url to the Gyldendal RichText editor library, so
   * we can inject it into the text wizard.
   */
  gEditor: string;
};

switch (process.env.APP_ENV ?? process.env.NODE_ENV) {
  case "production":
    urls = {
      basePath: "/viser/:courseId",
      mfOverview: "https://forloeb.gyldendal.dk/",
      gPanels: "https://plugins.gyldendal.dk/gPanels/v2.js",
      gExport: "https://exportservice.gyldendal.dk/gExport.js",
      gEditor: "https://plugins.gyldendal.dk/gEditor/v2.js",
    };
    break;

  case "staging":
    urls = {
      basePath: "/viser/:courseId",
      mfOverview: "https://qa-forloeb.gyldendal.dk/",
      gPanels: "https://qa-plugins.gyldendal.dk/gPanels/v2.js",
      gExport: "https://qa-exportservice.gyldendal.dk/gExport.js",
      gEditor: "https://qa-plugins.gyldendal.dk/gEditor/v2.js",
    };
    break;

  default:
    urls = {
      basePath: "/viser/:courseId",
      mfOverview: "https://test-forloeb.gyldendal.dk/",
      gPanels: "https://test-plugins.gyldendal.dk/gPanels/v2.js",
      gExport: "https://test-exportservice.gyldendal.dk/gExport.js",
      gEditor: "https://test-plugins.gyldendal.dk/gEditor/v2.js",
    };
}

export { urls };
